import { render, staticRenderFns } from "./LayoutFullbg.vue?vue&type=template&id=78d9750a&"
import script from "./LayoutFullbg.vue?vue&type=script&lang=js&"
export * from "./LayoutFullbg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports